import React, { useEffect, useState } from "react";
import MDBox from "../../components/MDBox";
import DashboardNavbar from "../../examples/Navbars/DashboardNavbar";
import DashboardLayout from "../../examples/LayoutContainers/DashboardLayout";
import Bill from "../billing/components/Bill";
import MDTypography from "../../components/MDTypography";
import MDButton from "../../components/MDButton";
import Icon from "@mui/material/Icon";
import { Link } from "react-router-dom";
import Card from "@mui/material/Card";
import { getAds } from "../../assets/firebaseFirestore";
import DeleteModal from "./DeleteModal";
import { useRecoilState } from "recoil";
import { advertisementState } from "../../recoilStates";

const Index = () => {

  const [modal, setModal] = useState(null);
  const [ads, setAds] = useRecoilState(advertisementState);

  const getAdvertisements = () => {
    getAds().then((res) => {
      setAds(res);
    });
  };

  useEffect(() => {
    getAdvertisements();
  }, []);

  return (
    <DashboardLayout>
      <DashboardNavbar />

      {
        modal ? <DeleteModal getAdvertisements={getAdvertisements} modal={modal} setModal={setModal} />
          : ""
      }

      <Card>
        <MDBox pt={2} px={2} display="flex" justifyContent="space-between" alignItems="center">
          <MDTypography variant="h5" fontWeight="medium">
            Advertisements
          </MDTypography>
          <Link to={"/createAd"}>
            <MDButton variant="gradient" color="primary">
              <Icon sx={{ fontWeight: "bold" }}>add</Icon>
              &nbsp;Create ad
            </MDButton>
          </Link>
        </MDBox>

        <MDBox pt={1} pb={2} px={2}>
          <MDBox component="ul" display="flex" flexDirection="column" p={0} m={0}>

            {
              ads.map((ad, index) => (
                <Bill key={`advertisement-${index}`} setModal={setModal} data={ad}
                />
              ))
            }

          </MDBox>
        </MDBox>

      </Card>

    </DashboardLayout>
  );
};

export default Index;
